import React from 'react';

import { useModalControls } from '@hooks';

import { BUTTON, TYPE } from './constants';

const TOOLBAR_ITEMS = [TYPE];

export const useCampaign = () => {
  const [type, setType] = React.useState();
  const modal = useModalControls(false);

  const configure = React.useCallback(
    ({ editor }) => {
      editor.ui.registry.addButton(BUTTON.type, {
        text: BUTTON.icon,
        tooltip: BUTTON.tooltip,
        onAction: () => {
          setType(BUTTON.type);
          modal.show();
        },
      });
    },
    [modal],
  );

  return { configure, type, modal, toolbarItems: TOOLBAR_ITEMS };
};
